module.exports = __webpack_public_path__ + "static/media/asc-vest.5882f6d5.svg";